import{observer,ComponentView,Preact,h,state,action,Router,Link,Cls,Media,JSX,m} from "@websites/website_compiler/Client";
import * as Stores from "../stores/ui";
import * as C from "./BaseCss";
import * as Icons from "./Icons"
import * as Css from "./OptionsCss";

export type divProps = JSX.IntrinsicElements["div"];
export type inputProps = JSX.IntrinsicElements["input"];
export type buttonProps = JSX.IntrinsicElements["button"];
export type aProps = JSX.IntrinsicElements["a"];
export type liProps = JSX.IntrinsicElements["li"];
export type labelProps = JSX.IntrinsicElements["label"];
export type textAreaProps = JSX.IntrinsicElements["textarea"];
type formProps = JSX.IntrinsicElements["form"];

interface InputType extends inputProps{
    error?:boolean;
}
interface labelExtended extends labelProps {required?:boolean}

export function Label(props:labelExtended){
    
    if(props.required == true){
        return <div class={C.rowCenterStart}>
                <label {...props} class={m(Css.label,props.class)}></label>
                <span class={Css.requiredLabel}>*</span>

            </div>
    }
    return <label {...props} class={m(Css.label,props.class)} ></label>
}
export function Input(props:InputType){
    return <input {...props} class={m(Css.input,props.error? C.errorBorder : null,props.class)}>{props.children}</input>
}
export function Row(props:divProps){
    return <div {...props} class={m(Css.row,props.class)} ></div>
}
export function DualRow(props:divProps){
    return <div {...props} class={m(Css.dualRow,props.class)} ></div>
}
export function Name(props:InputType){
    return  <input  pattern="[A-Za-z0-9_ ]+" minLength={1} maxLength={50}   required  type="text" {...props} class={m(Css.input,props.error? C.errorBorder : null,props.class)} error={null}></input>

}
export function Email(props:InputType){
    return <input {...props} type="email" class={m(Css.input,props.error? C.errorBorder : null,props.class)}>{props.children}</input>
}
export function Phone(props:InputType){
    return <input {...props} type="tel" class={m(Css.input,props.error? C.errorBorder : null,props.class)}>{props.children}</input>
}
export function Form(props:formProps){
    function onSubmit (e){
        e.preventDefault();
        console.log("onSubmit",e);
        props.onSubmit && (props as any).onSubmit(e);
    }
    return <form  {...props} onSubmit={onSubmit}></form>

}
export function TextArea(props:divProps){
    return <textarea {...props}  class={m(Css.textArea,props.class)}></textarea>
}
